import { render, staticRenderFns } from "./TrendingTokensCard.vue?vue&type=template&id=fa76a0e4&scoped=true"
import script from "./TrendingTokensCard.vue?vue&type=script&lang=ts"
export * from "./TrendingTokensCard.vue?vue&type=script&lang=ts"
import style0 from "./TrendingTokensCard.vue?vue&type=style&index=0&id=fa76a0e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76a0e4",
  null
  
)

export default component.exports